import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getApiCaller } from "../../libs/apiCaller";

const PendingRegistrationList = () => {
  const navigate = useNavigate();
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingProviders = async () => {
      try {
        const response = await getApiCaller("providers_list?type=pending");
        setProviders(response.data.response_data);
      } catch (error) {
        toast.error("Failed to fetch pending providers. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchPendingProviders();
  }, []);

  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full border border-1 rounded-xl min-w-[800px]">
          <thead className="bg-gray-50 rounded-t-xl">
            <tr>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Provider Name
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Service
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Joined Date
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Appointment Fee
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                License No
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="pt-5 pb-7 justify-items-center">
                  <PropagateLoader color="#284184" loading={true} size={10} />
                </td>
              </tr>
            ) : providers?.length === 0 ? (
              <tr>
                <td colSpan="7" className="pt-5 pb-7 text-center text-gray-500">
                  No Pending Registration Available
                </td>
              </tr>
            ) : (
              providers?.map((provider, index) => (
                <tr key={provider.id} className="border-b hover:bg-gray-50">
                  <td className="py-4 px-4">{index + 1}</td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                        <img
                          src={
                            provider.profile_picture ||
                            "https://via.placeholder.com/40"
                          }
                          alt={provider.first_name}
                          className="w-10 h-10 rounded-full"
                        />
                      </div>
                      {provider.first_name} {provider.last_name}
                    </div>
                  </td>
                  <td className="py-4 px-4">{provider.service_name}</td>
                  <td className="py-4 px-4">{provider.joined_date}</td>
                  <td className="py-4 px-4">${provider.appointment_fee}</td>
                  <td className="py-4 px-4">{provider.license_no}</td>
                  <td className="py-4 px-4">
                    <button
                      className="text-blue-600 hover:text-blue-800 underline"
                      onClick={() =>
                        navigate("/ProfileReview", { state: { provider } })
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PendingRegistrationList;
